/* @flow */

import {REHYDRATE} from 'redux-persist';

import {unexpectedCase} from 'nutshell-core/reducer-utils';

import type {OpenableModalId} from './openable-modals';
import {ActionTypes, type OpenableModalsAction} from './openable-modals-actions';

export type OpenableModalsState = {
    openModals: OpenableModalId[],
};

export const defaultOpenableModalsState: OpenableModalsState = {
    openModals: [],
};

export const openableModalsReducer = (
    state: OpenableModalsState = defaultOpenableModalsState,
    action: OpenableModalsAction
): OpenableModalsState => {
    switch (action.type) {
        case ActionTypes.MODAL_OPENED:
            return {
                openModals: [...state.openModals, action.id],
            };
        case ActionTypes.MODAL_CLOSED:
            return {
                openModals: state.openModals.filter(
                    (openModalId: OpenableModalId) => openModalId !== action.id
                ),
            };
        case REHYDRATE: {
            return state;
        }
        default:
            unexpectedCase(action.type);

            return state;
    }
};
